import React from "react";
import { Router, Route, Switch } from "react-router";
import Layout from "./components/Layout";
import history from "./helpers/history";
import PrivateRoute from "./components/PrivateRoute";
import User from "./components/User";
import Home from "./components/Home";
import Staff from "./components/Staff";
import Attorney from "./components/Attorney";
import PasswordReset from "./components/PasswordReset";
import ConfirmEmail from "./components/ConfirmEmail";

function App() {
  return (
    <Layout>
      <Router history={history}>
        <Switch>
          <PrivateRoute path="/user" component={User} />
          <PrivateRoute exact path="/user/questionnaire" component={User} />
          <PrivateRoute exact path="/user/appointment" component={User} />
          <PrivateRoute
            exact
            path="/user/updatePersonalInfo"
            component={User}
          />
          <PrivateRoute exact path="/user/updatePassword" component={User} />
          <PrivateRoute
            exact
            path="/user/updatePersonalInfo"
            component={User}
          />
          <PrivateRoute path="/staff" component={Staff} />
          <PrivateRoute path="/staff/updatePassword" component={Staff} />
          <PrivateRoute
            path="/staff/UpdateLitigantQuestionnaire"
            component={Staff}
          />
          <PrivateRoute path="/staff/ApproveAttorneys" component={Staff} />
          <PrivateRoute path="/staff/UpdateAttorneyInfo" component={Staff} />
          <PrivateRoute path="/attorney" component={Attorney} />
          <PrivateRoute path="/attorney/updatePassword" component={Attorney} />
          <PrivateRoute
            path="/attorney/updatePersonalInfo"
            component={Attorney}
          />
          <PrivateRoute
            path="/attorney/availableAppointments"
            component={Attorney}
          />
          <PrivateRoute
            path="/attorney/upcomingAppointments"
            component={Attorney}
          />

          <Route path="/PasswordReset" component={PasswordReset} />
          <Route path="/ConfirmEmail" component={ConfirmEmail} />
          <Route exact path="/" component={Home} />
        </Switch>
      </Router>
    </Layout>
  );
}

export default App;
